import { tryConvertDates } from 'common/serialization'
import type { RequestResult } from 'common/network/request-options'
import store from '../store'
import { ApplicationException } from '../api/ApplicationException'
import { clearState } from '../localstorage'

export const handleUnauthorizedResponse = (status: number, responseUrl: string): void => {
  if (status !== 401 || store.getState().userReducer.changingUser) return

  clearState()
  document.cookie = 'edgetoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT'
  if (responseUrl !== '/api/login/' && window.location.hash !== '#/') {
    window.location.assign('/')
  }
}

export const makeHttpApplicationException = (
  status: number,
  statusText: string,
  body: any,
  origin: unknown,
): ApplicationException => {
  const defaultTitle = `Unexpected status code: ${status}`
  const { title, detail } = body || {}

  return new ApplicationException({
    fatal: status !== 409,
    errorCode: `${status}`,
    text: title || defaultTitle,
    details: detail || title || statusText,
    origin,
  })
}

export const fetch = async <T>(...args: Parameters<typeof window.fetch>): Promise<RequestResult<T>> => {
  const response = await window.fetch(...args)
  const contentType = response.headers.get('content-type')
  const body = contentType?.includes('application/json')
    ? tryConvertDates(await response.json())
    : await response.text()

  if (!response.ok) {
    handleUnauthorizedResponse(response.status, response.url)
    throw makeHttpApplicationException(response.status, response.statusText, body, '')
  }

  return {
    status: response.status,
    headers: Object.fromEntries(response.headers.entries()),
    body,
  }
}
